import { Pencil, Power, PowerOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export interface RowActionsProps {
  onEdit: () => void;
  isActive: boolean;
  /** Withdrawing goes through a confirmation, reactivating does not — it takes nothing away. */
  onDeactivate?: () => void;
  onActivate?: () => void;
}

/**
 * The row actions of the referential and directory screens: edit, and withdraw or restore.
 * Rendered only for an account that may manage — a view-only one gets no action rather than a
 * button that 403s, so the caller drops the whole column instead of disabling what is inside it.
 * The two lifecycle handlers are optional: the technician directory carries edit alone, because
 * L2a put activation on the record.
 */
const RowActions = ({ onEdit, isActive, onDeactivate, onActivate }: RowActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-1">
      <button
        onClick={onEdit}
        className="rounded p-1.5 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-950/40"
        title={t('Edit')}
        aria-label={t('Edit')}
      >
        <Pencil className="h-4 w-4" />
      </button>
      {onDeactivate && onActivate && (
        <button
          onClick={isActive ? onDeactivate : onActivate}
          className="rounded p-1.5 text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800"
          title={isActive ? t('Deactivate') : t('Activate')}
        >
          {isActive ? <PowerOff className="h-4 w-4" /> : <Power className="h-4 w-4" />}
        </button>
      )}
    </div>
  );
};

export default RowActions;
